// Mobile nav toggler
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 1200) {
    document.body.classList.add("has-mobile-nav");
  }

  // Toggle mobile menu
  const menuToggle = document.querySelector(".menu-toggle");
  const mobileMenuWrapper = document.querySelector(".mobile-menu-wrapper");

  if (menuToggle) {
    menuToggle.addEventListener("click", function () {
      this.classList.toggle("active");
      mobileMenuWrapper.classList.toggle("active");
      document.body.classList.toggle("mobile-nav-is-open");

      const isExpanded = this.classList.contains("active");
      this.setAttribute("aria-expanded", isExpanded);
    });
  }

  // Toggle submenus for mobile with accordion behavior
  const menuItemsWithChildren = document.querySelectorAll(
    ".mobile-menu-items .menu-item-has-children > a"
  );

  menuItemsWithChildren.forEach((item) => {
    item.addEventListener("click", function (e) {
      e.preventDefault();

      const currentParent = this.parentNode;
      const isCurrentlyOpen = currentParent.classList.contains("submenu-open");

      // Close all open submenus first
      const allOpenSubmenus = document.querySelectorAll(
        ".mobile-menu-items .menu-item-has-children.submenu-open"
      );
      allOpenSubmenus.forEach((openItem) => {
        openItem.classList.remove("submenu-open");
      });

      // If the clicked item wasn't open before, open it
      if (!isCurrentlyOpen) {
        currentParent.classList.add("submenu-open");
      }
    });
  });

  // Handle window resize
  window.addEventListener("resize", function () {
    if (window.innerWidth < 1200) {
      document.body.classList.add("has-mobile-nav");
    } else {
      document.body.classList.remove("has-mobile-nav");
    }
  });
});
